module.exports = __webpack_public_path__ + "images/emoji/rage1.99af14cd4602ac04b9f1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rage1.png
// module id = 56Vu
// module chunks = 13